import React from 'react';
import { Lightbulb, TrendingUp, AlertCircle, CheckCircle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../components/ui/card';
import BackButton from '../../../components/admin/BackButton';

const AssistantInsights = () => {
  const insights = [
    {
      title: "Revenue Trend",
      message: "Your revenue increased by 12% this month",
      type: "positive",
      icon: TrendingUp,
      color: "text-green-600",
      bgColor: "bg-green-100"
    },
    {
      title: "Client Engagement",
      message: "3 clients haven't been contacted in over 30 days",
      type: "warning",
      icon: AlertCircle,
      color: "text-yellow-600",
      bgColor: "bg-yellow-100"
    },
    {
      title: "Invoice Collection",
      message: "All invoices from last month have been paid",
      type: "positive",
      icon: CheckCircle,
      color: "text-green-600",
      bgColor: "bg-green-100"
    }
  ];

  return (
    <div>
      <BackButton />
      
      <div className="mb-8">
        <div className="flex items-center space-x-3">
          <div className="p-3 bg-orange-500 bg-opacity-10 rounded-lg">
            <Lightbulb className="h-6 w-6 text-orange-600" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-[#2B2D42]">AI Insights</h2>
            <p className="text-sm text-[#6C757D]">Intelligent business insights and recommendations</p>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        {insights.map((insight, index) => {
          const Icon = insight.icon;
          return (
            <Card key={index}>
              <CardContent className="pt-6">
                <div className="flex items-start space-x-4">
                  <div className={`${insight.bgColor} p-3 rounded-lg`}>
                    <Icon className={`h-6 w-6 ${insight.color}`} />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-[#2B2D42] mb-1">{insight.title}</h3>
                    <p className="text-sm text-[#6C757D]">{insight.message}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card className="mt-8 bg-orange-50 border-orange-200">
        <CardContent className="pt-6">
          <p className="text-sm text-[#6C757D]">
            💡 <strong>AI Insights</strong> will analyze your platform data and provide actionable recommendations. 
            This feature is under development.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AssistantInsights;